<template lang="pug">
  .PDFDocument( ref="viewport" )
    .placeholder( v-if="loading" )
      content-placeholders.placeholder-dark( :rounded="true" )
      content-placeholders-text( :lines="30" :rounded="true" :centered="true" )
    .loading-default( v-if="loading" )
      svg.filter( version="1.1" )
        defs
          filter( id="gooeyness" )
            feGaussianBlur( in="SourceGraphic" stdDeviation="10" result="blur" )
            feColorMatrix( in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -10" result="gooeyness" )
            feComposite( in="SourceGraphic" in2="gooeyness" operator="atop" )
      .dots
        .dot.mainDot
        .dot
        .dot
        .dot
        .dot

</template>
<script>
import * as PDFJS from 'pdfjs-dist/build/pdf.js'
import langOps from '@/mixins/langOps'
const PDFWorker = import('pdfjs-dist/build/pdf.worker.entry.js')
export default {
  name: 'Document-pdf',
  mixins: [langOps],
  props: {
    type: String,
    name: {
      type: String,
      require: true,
      default: ''
    },
    fileLang: {
      type: String,
      default: 'ru'
    }
  },
  data () {
    return {
      loading: true,
      PDFData: {},
      list: []
    }
  },
  computed: {
    url () {
      return `${process.env.VUE_APP_DOCUMENT_STORAGE}/${this.fileLang}/${this.name}.pdf`
    },
    locale () {
      return this.lang.match(/en|kk|uk/gi) ? this.lang : 'ru'
    }
  },
  methods: {
    render () {
      this.loading = false
      this.list.forEach(item => {
        if (!this.$refs.viewport) {
          return
        }
        this.$refs.viewport.appendChild(item)
      })
    },
    createPage (index, page) {
      const options = {
        scale: 1.5
      }
      const viewport = page.getViewport({ scale: options.scale })
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d', { alpha: false })
      canvas.height = viewport.height
      canvas.width = viewport.width
      page.render({
        canvasContext: context,
        viewport: viewport
      })
      this.list[index] = canvas
      return Promise.resolve()
    },
    renderPages () {
      const count = this.PDFData.numPages
      let index = 1
      const doPage = () => {
        if (index > count) {
          this.render()
        } else {
          this.PDFData.getPage(index).then(page => {
            this.createPage(index, page).then(() => {
              if (index <= count) {
                index++
                doPage()
              }
            })
          })
        }
      }
      doPage()
    },
    loadConfig () {
      PDFJS.GlobalWorkerOptions.workerSrc = PDFWorker
    },
    loadPDF () {
      PDFJS.getDocument(this.url).promise.then(pdf => {
        this.PDFData = pdf
        this.renderPages()
      })
    },
    init () {
      this.loadConfig()
      this.loadPDF()
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="scss">
.PDFDocument {
  //@media(min-width: 640px) {
  //  canvas {
  //    width: 100% !important;
  //    max-width: 894px !important;
  //    display: block;
  //    margin: 0 auto;
  //  }
  //}
  //@media(max-width: 480px) {
  //  canvas {
  //    width: 150% !important;
  //  }
  //}
  width: 100%;
  padding-top: 2rem;
  position: relative;
  min-height: 100%;
  .placeholder{
    display: block;
    width: 100%;
    max-width: 894px;
    margin: 0 auto;
    background: #fff;
    padding: 10vh 5vw;
  }
  .loading-default{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
  }
  canvas{
    display: block;
    margin: 0 auto;
    margin-bottom: 2rem;
  }
}
</style>
